<template>
  <li class="nav-item" v-if="model.url">
    <NuxtLink :to="model.url" class="nav-link" @click="handleClick">
      {{ model.title }}
    </NuxtLink>
  </li>
  <NavigationItemComponent
    v-for="(item, i) in model.subItems"
    :model="item"
    :index="i"
    :is-sub-item="true"
  />
</template>

<script lang="ts" setup>
import { inject } from 'vue'
import type { NavigationItem } from '~~/app/types/shared/NavigationItem'
const props = defineProps<{ model: NavigationItem; index: number; isSubItem?: boolean }>()
const route = useRoute();

const collapseNavbar = inject('collapseNavbar') as (() => void) | undefined
const isActive = computed(() => route.path == props.model.url);
const handleClick = () => {
  if (collapseNavbar) collapseNavbar()

  if (isActive.value){
    scrollTo({top: 0, behavior:'smooth'});
  }
  
}

</script>
